module.exports = __webpack_public_path__ + "static/media/return_icon.5fabd9e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/icons/return_icon.svg
// module id = 1937
// module chunks = 1